module.exports = __webpack_public_path__ + "static/img/Gradient.887f2e77.png";